import React, { useEffect, useRef } from "react";
import {
  Tooltip,
  makeStyles,
  TableCell,
  TableRow,
  TableCellLayout,
  PopoverTrigger,
  Popover,
  PopoverSurface,
} from "@fluentui/react-components";
import {
  FlagIcon,
  MeatBallsMenuIcon,
  PlusIcon,
  PlusIconWhite,
} from "../../../../../modules/default-svg";
import { useDispatch } from "react-redux";
import { generalActions } from "../../../../../store/actions";
import { apiCall } from "../../../../../store/services/service";
import {
  BASE_URL,
  URL_SEARCH_CLIENT_PORTFOLIO,
} from "../../../../../store/services/URL";
import clientService from "../../../../../store/services/clients.service";
import CustomInput from "../../../input/customInput/CustomInput";
import CustomSelect from "../../../select/CustomSelect";
import TextArea from "../../../textarea/Textarea";

import { useHistory } from "react-router-dom";
import useNavigation from "../../../../../utils/useNavigation";
import { useState } from "react";
import {
  createCommunicationPlanRequest,
  updateCommunicationPlanRequest,
} from "../../../../../store/actions/communications.actions";
import Button from "../../../button";
import { getLabelByType, communicationCategoryOptions } from "../../../../../helpers/utils";
import DropDown from "../../../dropdown/DropdownFluent";

const useStyles = makeStyles({
  tooltip: {
    backgroundColor: "#342c82",
    color: "#FFFFFF",
  },
});

const CommunicationPlanRow = (props) => {
  const {
    parentType,
    sortingCriteria,
    data,
    handleModal,
    sortCommunicationPlansRequest,
    portfolioId,
    projectId,
    programId,
    clientId,
    menu,
    updateFlag,
    columnConfig,
  } = props;
  const [sortedData, setSortedData] = useState([]);
  const [flagged, setFlagged] = useState([]);
  const [popoverOpen, setPopoverOpen] = useState({});
  const [isEditRecord, setIsEditRecord] = useState(null);
  const popoverRef = useRef(null);
  const [clients, setClients] = useState([]);
  const [portfolioOptions, setPortfolioOptions] = useState([]);
  const [projectOptions, setProjectOptions] = useState([]);
  const [programs, setPrograms] = useState([]);
  const [formErrors, setFormErrors] = useState({
    scopeName: "",
    startDate: "",
    endDate: "",
    revisedEndDate: "",
    completion: "",
    projectId: "",
  });
  const history = useHistory();
  const { navigateTo } = useNavigation();
  const dispatch = useDispatch();
  const titleInputRef = useRef(null);
  const messageInputRef = useRef(null);
  const audienceInputRef = useRef(null);
  const frequencyInputRef = useRef(null);
  const mediumInputRef = useRef(null);
  const sourceInputRef = useRef(null);
  const expeditatorInputRef = useRef(null);
  const statusInputRef = useRef(null);
  const purposeInputRef = useRef(null);
  const resultInputRef = useRef(null);
  const portfolioInputRef = useRef(null);
  const categoryInputRef = useRef();

  const handleBlur = () => {
    let data = { ...isEditRecord.name };
    if (data.client) {
      data.clientId = data.client.id;
      delete data.client;
    } else {
      delete data.client;
    }
    if (data.portfolio) {
      data.portfolioId = data.portfolio.id;
      delete data.portfolio;
    } else {
      delete data.portfolio;
    }

    if (data.program) {
      data.programId = data.program.id;
      delete data.program;
    } else {
      delete data.program;
    }

    if (data.project) {
      data.projectId = data.project.id;
      delete data.project;
    } else {
      delete data.project;
    }

    delete data.owner;
    delete data.actual;
    delete data.accural;
    delete data.bac;
    delete data.etc;
    delete data.isFlagged;
    delete data.dateCreated;

    const dat = { payload: data };
    dat.parent = parentType;

    if (parentType === "Client") {
      dat.id = clientId;
      dat.parent = "Client";
      dat.payload.clientId = clientId;
    }
    if (parentType === "Project") {
      dat.id = projectId;
      dat.parent = "Project";
      dat.payload.projectId = projectId;
    }
    if (parentType === "Program") {
      dat.id = programId;
      dat.parent = "Program";
      dat.payload.programId = programId;
    }
    if (parentType === "Portfolio") {
      dat.id = portfolioId;
      dat.parent = "Portfolio";
      dat.payload.portfolioId = portfolioId;
    }
    dat.sId = isEditRecord.name.id;
    if (data.title) {
      if (data.id) {
        dispatch(updateCommunicationPlanRequest(dat));
      } else {
        dispatch(createCommunicationPlanRequest(dat));
      }
      setIsEditRecord(null);
    } else {
      const errors = {};
      if (!data.title) errors["title"] = `The Name field is required.`;
      // if (!data.project) errors["projectId"] = `The Project field is required.`;
      setFormErrors(errors);
      if (!data.title) {
        return dispatch(
          generalActions.showToast({
            title: "Title is a required field",
            type: "error",
          })
        );
      }
      // console.log("errors", errors);
      // else if (!data.project) {
      //   return dispatch(
      //     generalActions.showToast({
      //       title: "Project is a required field",
      //       type: "error",
      //     })
      //   );
      // }
    }
  };

  const handleEditable = (event) => {
    if (event.key === "Escape") {
      setIsEditRecord(null);
    } else if (event.key === "Enter") {
      if (isEditRecord) {
        handleBlur();
      }
    }
  };

  const handleInputChange = (value, type) => {
    let error = { ...formErrors };
    const data = JSON.parse(JSON.stringify(isEditRecord));
    if (type === "title") {
      error["title"] = ``;
      setFormErrors(error);
      data.name.title = value;
      setIsEditRecord(data);
    } else if (type === "message") {
      data.name.message = value;
      setIsEditRecord(data);
    } else if (type === "audience") {
      data.name.audience = value;
      setIsEditRecord(data);
    } else if (type === "frequency") {
      data.name.time = value;
      setIsEditRecord(data);
    } else if (type === "medium") {
      data.name.medium = value;
      setIsEditRecord(data);
    } else if (type === "source") {
      data.name.source = value;
      setIsEditRecord(data);
    } else if (type === "expeditor") {
      data.name.expeditor = value;
      setIsEditRecord(data);
    } else if (type === "status") {
      data.name.status = value;
      setIsEditRecord(data);
    } else if (type === "purpose") {
      data.name.highlights = value;
      setIsEditRecord(data);
    } else if (type === "result") {
      data.name.results = value;
      setIsEditRecord(data);
    } else if (type === "project") {
      error["projectId"] = ``;
      setFormErrors(error);
      if (!value) {
        data.name.project = null;
      } else {
        if (!data.name?.project) {
          data.name.project = {};
        }
        data.name.project.name = value.label;
        data.name.project.id = value.value;
      }
      setIsEditRecord(data);
    } else if (type === "client") {
      if (!value) {
        data.name.client = null;
      } else {
        if (!data.name?.client) {
          data.name.client = {};
        }
        data.name.client.name = value.label;
        data.name.client.id = value.value;
      }
      data.name.project = null;
      data.name.portfolio = null;
      data.name.program = null;
      setIsEditRecord(data);
    } else if (type === "portfolio") {
      if (!value) {
        data.name.portfolio = null;
      } else {
        if (!data.name?.portfolio) {
          data.name.portfolio = {};
        }
        data.name.portfolio.name = value.label;
        data.name.portfolio.id = value.value;
      }
      data.name.program = null;
      data.name.project = null;
      setIsEditRecord(data);
    } else if (type === "program") {
      if (!value) {
        data.name.program = null;
      } else {
        if (!data.name?.program) {
          data.name.program = {};
        }
        data.name.program.name = value.label;
        data.name.program.id = value.value;
      }
      data.name.project = null;
      setIsEditRecord(data);
    } else if (type === "category") {
      data.name.category = value;
      setIsEditRecord(data);
    }
  };

  const handleIsEdiRecord = (index, type) => {
    if (index === data.length && type !== "title") {
      sortedData[index] = {
        ...isEditRecord?.name,
      };
    }
    setIsEditRecord({ index: index, name: sortedData[index] });
    setTimeout(() => {
      switch (type) {
        case "title":
          titleInputRef?.current.focus();
          break;
        case "message":
          messageInputRef?.current?.focus();
          break;
        case "audience":
          audienceInputRef?.current?.focus();
          break;
        case "portfolio":
          portfolioInputRef?.current?.focus();
          break;
        case "frequency":
          frequencyInputRef?.current?.focus();
          break;
        case "medium":
          mediumInputRef?.current?.focus();
          break;
        case "source":
          sourceInputRef?.current?.focus();
          break;
        case "expeditor":
          expeditatorInputRef?.current?.focus();
          break;
        case "status":
          statusInputRef?.current?.focus();
          break;
        case "purpose":
          purposeInputRef?.current?.focus();
          break;
        case "result":
          resultInputRef?.current?.focus();
          break;
        case "category":
          categoryInputRef?.current?.focus();
          break;
        default:
          break;
      }
    }, 0);
  };

  const searchClientHandler = (value) => {
    if (value === "") {
      setClients([]);
      return;
    }
    clientService
      .searchClientsRequest(value)
      .then((res) => {
        const transformedArray = res.map((obj) => ({
          label: obj.name,
          value: obj.id,
        }));
        setClients(transformedArray);
      })
      .catch(() => {
        setClients([]);
      });
  };

  const searchProjectHandler = (value) => {
    if (value === "") {
      setProjectOptions([]);
      return;
    }
    const payload = { searchText: value };
    let queryParam = `?searchTerm=${payload.searchText}`;
    payload.parent = "Budget";

    if (isEditRecord?.name?.client) {
      queryParam = `?clientId=${isEditRecord?.name?.client?.id}&searchTerm=${payload.searchText}`;
    }

    if (isEditRecord?.name?.portfolio) {
      queryParam = `?portfolioId=${isEditRecord?.name?.portfolio?.id}&searchTerm=${payload.searchText}`;
    }

    if (isEditRecord?.name?.program) {
      queryParam = `?programId=${isEditRecord?.name?.program?.id}&searchTerm=${payload.searchText}`;
    }

    if (isEditRecord?.name?.client && isEditRecord?.name?.portfolio) {
      queryParam = `?clientId=${isEditRecord?.name?.client?.id}&portfolioId=${isEditRecord?.name?.portfolio?.id}&searchTerm=${payload.searchText}`;
    }

    if (isEditRecord?.name?.client && isEditRecord?.name?.program) {
      queryParam = `?clientId=${isEditRecord?.name?.client?.id}&programId=${isEditRecord?.name?.program?.id}&searchTerm=${payload.searchText}`;
    }

    if (isEditRecord?.name?.portfolio && isEditRecord?.name?.program) {
      queryParam = `?portfolioId=${isEditRecord?.name?.portfolio.id}&programId=${isEditRecord?.name?.program?.id}&searchTerm=${payload.searchText}`;
    }

    if (
      isEditRecord?.name?.client &&
      isEditRecord?.name?.portfolio &&
      isEditRecord?.name?.program
    ) {
      queryParam = `?clientId=${isEditRecord?.name?.client?.id}&portfolioId=${isEditRecord?.name?.portfolio?.id}&programId=${isEditRecord?.name?.program?.id}&searchTerm=${payload.searchText}`;
    }

    if (parentType === "Program") {
      queryParam = queryParam + `&programId=${programId}`;
    } else if (parentType === "Portfolio") {
      queryParam = queryParam + `&portfolioId=${portfolioId}`;
    }

    apiCall
      .get({ url: `${BASE_URL}search/Projects${queryParam}` })
      .then((res) => {
        const transformedArray = res.map((obj) => ({
          start: obj.startDate,
          end: obj.endDate,
          label: obj.name,
          value: obj.id,
        }));
        setProjectOptions(transformedArray);
      })
      .catch(() => {
        setProjectOptions([]);
      });
  };

  const searchProgramHandler = (value) => {
    if (value === "") {
      setPrograms([]);
      return;
    }
    const payload = { searchText: value };
    let queryParam = `?searchTerm=${payload.searchText}`;

    payload.parent = "Project";

    if (isEditRecord?.name?.client) {
      queryParam = `?clientId=${isEditRecord?.name?.client?.id}&searchTerm=${payload.searchText}`;
    }

    if (isEditRecord?.name?.portfolio) {
      queryParam = `?portfolioId=${isEditRecord?.name?.portfolio.id}&searchTerm=${payload.searchText}`;
    }

    if (isEditRecord?.name?.client && isEditRecord?.name?.portfolio) {
      queryParam = `?clientId=${isEditRecord?.name?.client.id}&portfolioId=${isEditRecord?.name?.portfolio.id}&searchTerm=${payload.searchText}`;
    }

    if (parentType === "Portfolio") {
      queryParam = queryParam + `&portfolioId=${portfolioId}`;
    }

    apiCall
      .get({ url: `${BASE_URL}search/Programs${queryParam}` })
      .then((res) => {
        const transformedArray = res.map((obj) => ({
          label: obj.name,
          value: obj.id,
        }));
        setPrograms(transformedArray);
      })
      .catch(() => {
        setPrograms([]);
      });
  };

  const searchPortfolioHandler = (value) => {
    if (value === "") {
      setPortfolioOptions([]);
      return;
    }
    const payload = { id: isEditRecord?.name?.client?.id, searchText: value };
    let queryParam = `?searchTerm=${payload.searchText}`;
    if (isEditRecord?.name?.client)
      queryParam = `?clientId=${payload.id}&searchTerm=${payload.searchText}`;
    apiCall
      .get({
        url: `${URL_SEARCH_CLIENT_PORTFOLIO}${queryParam}`,
        isAuthToken: true,
      })
      .then((res) => {
        const transformedArray = res.map((obj) => ({
          label: obj.name,
          value: obj.id,
        }));
        setPortfolioOptions(transformedArray);
      })
      .catch(() => {
        setPortfolioOptions([]);
      });
  };

  useEffect(() => {
    if (sortingCriteria.column !== null) {
      const data = {
        page: 1,
        size: 10,
        orderBy: `${sortingCriteria.column} ${sortingCriteria.order}`,
      };
      data.parent = parentType;
      if (parentType === "Client") {
        data.id = clientId;
        data.parent = parentType;
      }
      if (parentType === "Project") {
        data.id = projectId;
        data.parent = parentType;
      }
      if (parentType === "Program") {
        data.id = programId;
        data.parent = parentType;
      }

      if (parentType === "Portfolio") {
        data.id = portfolioId;
        data.parent = parentType;
      }
      sortCommunicationPlansRequest(data);
    }
  }, [sortingCriteria]);

  useEffect(() => {
    if (typeof data != "string") {
      data
        .filter((d) => d.isFlagged)
        .map((f) => {
          if (!flagged.includes(f.id)) {
            setFlagged((prevItems) => [...prevItems, f.id]);
          }
        });
      const tempData = [...data];
      tempData.push({
        name: "",
        client: null,
        portfolio: null,
        program: null,
        project: null,
        message: null,
        audience: "",
        time: "",
        medium: "",
        source: "",
        expeditor: "",
        status: "",
        highlights: "",
        results: "",
        category: 0,
      });
      setSortedData(tempData);
    }
  }, [data]);

  useEffect(() => {
    if (menu.props.closePopover) {
      setPopoverOpen(null);
    }
  }, [menu.props.closePopover]);

  const handlePopoverOpen = (rowId) => {
    setPopoverOpen(rowId);
  };

  const handleClientRedirect = (item) => {
    if (parentType !== "Client") {
      // Use navigation hook for direct navigation to client
      navigateTo("Clients", item.client.id, item.client.name);
    } else {
      // Already in client context, just navigate
      history.push(`/clients/${item.client.id}/overview`);
    }
  };

  const handlePortfolioRedirect = (item) => {
    if (item.portfolio) {
      if (parentType !== "Portfolio") {
        // Use navigation hook for direct navigation to portfolio
        navigateTo(
          "Portfolios",
          item.portfolio.id,
          item.portfolio.name
        );
      } else {
        // Already in portfolio context, just navigate
        history.push(`/portfolio/${item.portfolio.id}/overview`);
      }
    }
  };

  const handleProgramRedirect = (item) => {
    if (item.program) {
      if (parentType !== "Program") {
        // Use navigation hook for direct navigation to program
        navigateTo("Programs", item.program.id, item.program.name);
      } else {
        // Already in program context, just navigate
        history.push(`/program/${item.program.id}/overview`);
      }
    }
  };

  const handleProjectRedirect = (item) => {
    if (item.project) {
      // Use navigation hook for direct navigation to project
      navigateTo("Projects", item.project.id, item.project.name);
    }
  };

  const handleClickOutside = (event) => {
    if (
      popoverRef.current &&
      !popoverRef.current.contains(event.target) &&
      event.target?.innerText !== "Edit" &&
      event.target?.innerText !== "Delete" &&
      event.target?.innerText !== "Remind me" &&
      event?.target?.tagName !== "svg"
    ) {
      if (popoverOpen) {
        handlePopoverOpen(null);
      }
    }
    if (
      isEditRecord &&
      event.target.localName !== "input" &&
      event.target.localName !== "textarea" &&
      event.target.localName !== "div" &&
      event.target.className && // Ensure className exists
      typeof event.target.className === "string" && // Ensure className is a string
      !event.target.className.includes("fui-Dropdown__button")
    ) {
      handleBlur();
    } else if (isEditRecord && event.target.placeholder === "Search") {
      handleBlur();
    }
  };

  const handleScroll = (e) => {
    handlePopoverOpen(null);
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    window.addEventListener("wheel", handleScroll);
    document.addEventListener("keydown", handleEditable);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      window.removeEventListener("wheel", handleScroll);
      document.removeEventListener("keydown", handleEditable);
    };
  }, [isEditRecord, popoverOpen]);

  const addFlag = (id) => {
    setFlagged((prevItems) => [...prevItems, id]);
    updateFlag({
      id: id,
      payload: [
        {
          op: "replace",
          path: "/IsFlagged",
          value: true,
        },
      ],
    });
  };

  const removeFlag = (id) => {
    setFlagged((prevItems) => prevItems.filter((item) => item !== id));
    updateFlag({
      id: id,
      payload: [
        {
          op: "replace",
          path: "/IsFlagged",
          value: false,
        },
      ],
    });
  };

  useEffect(() => {
    const sortedArray = data;
    const tempData = [...sortedArray];
    tempData.push({
      name: "",
      client: null,
      portfolio: null,
      program: null,
      project: null,
      message: null,
      audience: "",
      time: "",
      medium: "",
      source: "",
      expeditor: "",
      status: "",
      highlights: "",
      results: "",
      category: 0
    });
    setSortedData(tempData);
  }, [flagged]);

  const sortDataByFlagged = (dataArray, flaggedArray) => {
    const flaggedItems = [];
    const remainingItems = [];

    dataArray.forEach((item) => {
      if (flaggedArray.includes(item.id)) {
        flaggedItems.push(item);
      } else {
        remainingItems.push(item);
      }
    });

    flaggedItems.sort((a, b) => {
      return flaggedArray.indexOf(a.id) - flaggedArray.indexOf(b.id);
    });

    return [...flaggedItems, ...remainingItems];
  };

  const sortedColumnConfig = [...columnConfig].sort(
    (a, b) => a.order - b.order
  );

  const renderTableCell = (item, index, column) => {
    const isEditing = isEditRecord && isEditRecord.index === index;

    switch (column.label) {
      case "Title":
        return (
          <TableCell>
            <div className="d-flex justify-content-between align-items-center inputWidth">
              <div className="d-flex align-items-center inputWidth">
                {item?.id && (
                  <Tooltip
                    positioning="before"
                    content={{
                      children: flagged.includes(item.id) ? "Unflag" : "Flag",
                      className: styles.tooltip,
                    }}
                    relationship="label"
                    withArrow
                  >
                    <span
                      className={`flag ${
                        flagged.includes(item.id) ? "flagActive" : ""
                      }`}
                      onClick={() =>
                        flagged.includes(item.id)
                          ? removeFlag(item.id)
                          : addFlag(item.id)
                      }
                    >
                      <FlagIcon />
                    </span>
                  </Tooltip>
                )}
                {isEditing ? (
                  <CustomInput
                    inputwd="inputWidth me-3"
                    icon={false}
                    placeholder="Add Communication name"
                    value={isEditRecord.name.title}
                    type="text"
                    handleChange={(value) =>
                      handleInputChange(value, "title")
                    }
                    ref={titleInputRef}
                    errorMessage={formErrors.title}
                    displayErrorMessage={false}
                  />
                ) : item?.id ? (
                  <span
                    className="d-flex w-full text-truncate"
                    onClick={() => handleIsEdiRecord(index, "title")}
                  >
                    {item.title}
                  </span>
                ) : (
                  <div
                    className="d-flex _add_btn"
                    onClick={() =>
                      handleIsEdiRecord(sortedData.length - 1, "title")
                    }
                  >
                    <PlusIcon />
                    Add
                  </div>
                )}
              </div>
              {item?.id && (
                <div className="flag">
                  <Popover
                    {...props}
                    open={popoverOpen === item.id}
                    onOpenChange={(isOpen) =>
                      isOpen && handlePopoverOpen(item.id)
                    }
                    positioning="below-start"
                  >
                    <PopoverTrigger disableButtonEnhancement>
                      <TableCellLayout
                        media={<MeatBallsMenuIcon />}
                        onClick={() => handleModal(item)}
                      />
                    </PopoverTrigger>
                    <PopoverSurface
                      tabIndex={-1}
                      className="listingPopoverWrapper"
                    >
                      {menu}
                    </PopoverSurface>
                  </Popover>
                </div>
              )}
            </div>
          </TableCell>
        );
      case "Client":
        if (parentType === "Client") return null;
        return isEditing ? (
          <TableCell className={isEditing ? "" : "hoverCell"}>
            <CustomSelect
              SelectText="client"
              searchText={searchClientHandler}
              options={clients}
              defaultVal={
                isEditRecord.name.client
                  ? {
                      label: isEditRecord.name.client.name,
                      value: isEditRecord.name.client.id,
                    }
                  : null
              }
              onChange={(e) => handleInputChange(e, "client")}
              CustomClass="ModalAvatarSearch"
            />
          </TableCell>
        ) : item.client ? (
          <TableCell
            className={isEditing ? "" : "hoverCell"}
            onClick={() => handleIsEdiRecord(index, "client")}
          >
            <span onClick={() => handleClientRedirect(item)}>
              {item.client?.name}
            </span>
          </TableCell>
        ) : (
          <TableCell onClick={() => handleIsEdiRecord(index, "client")} />
        );
      case "Portfolio":
        if (parentType === "Portfolio") return null;
        return isEditing ? (
          <TableCell className={isEditing ? "" : "hoverCell"}>
            <CustomSelect
              CustomClass="ModalAvatarSearch"
              persona={true}
              searchText={searchPortfolioHandler}
              SelectText="portfolio"
              options={portfolioOptions}
              defaultVal={
                isEditRecord.name.portfolio?.name
                  ? {
                      label: isEditRecord.name.portfolio.name,
                      value: isEditRecord.name.portfolio.id,
                    }
                  : null
              }
              onChange={(e) => handleInputChange(e, "portfolio")}
            />
          </TableCell>
        ) : item.portfolio ? (
          <TableCell
            className={isEditing ? "" : "hoverCell"}
            onClick={() => handleIsEdiRecord(index, "portfolio")}
          >
            <span onClick={() => handlePortfolioRedirect(item)}>
              {item.portfolio?.name}
            </span>
          </TableCell>
        ) : (
          <TableCell onClick={() => handleIsEdiRecord(index, "portfolio")} />
        );
      case "Program":
        if (parentType === "Program") return null;
        return isEditing ? (
          <TableCell className={isEditing ? "" : "hoverCell"}>
            <CustomSelect
              SelectText="program"
              searchText={searchProgramHandler}
              options={programs}
              defaultVal={
                isEditRecord.name.program?.name
                  ? {
                      label: isEditRecord.name.program.name,
                      value: isEditRecord.name.program.id,
                    }
                  : null
              }
              onChange={(e) => handleInputChange(e, "program")}
              CustomClass="ModalAvatarSearch"
            />
          </TableCell>
        ) : item.program ? (
          <TableCell
            className={isEditing ? "" : "hoverCell"}
            onClick={() => handleIsEdiRecord(index, "program")}
          >
            <span onClick={() => handleProgramRedirect(item)}>
              {item.program?.name}
            </span>
          </TableCell>
        ) : (
          <TableCell onClick={() => handleIsEdiRecord(index, "program")} />
        );
      case "Project":
        if (parentType === "Project") return null;
        return isEditing ? (
          <TableCell>
            <CustomSelect
              SelectText="project"
              searchText={searchProjectHandler}
              options={projectOptions}
              defaultVal={
                isEditRecord.name.project?.name
                  ? {
                      label: isEditRecord.name.project.name,
                      value: isEditRecord.name.project.id,
                    }
                  : null
              }
              onChange={(e) => handleInputChange(e, "project")}
              CustomClass="ModalAvatarSearch"
              errorMessage={formErrors.projectId}
              displayErrorMessage={false}
            />
          </TableCell>
        ) : item.project ? (
          <TableCell
            className={isEditing ? "" : "hoverCell"}
            onClick={() => handleIsEdiRecord(index, "project")}
          >
            <span onClick={() => handleProjectRedirect(item)}>
              {item.project?.name}
            </span>
          </TableCell>
        ) : (
          <TableCell onClick={() => handleIsEdiRecord(index, "project")} />
        );
      case "Message":
        return (
          <TableCell
            className="Description"
            onClick={() => handleIsEdiRecord(index, "message")}
          >
            {isEditing ? (
              <TextArea
                placeholder="Enter message"
                value={isEditRecord.name.message}
                onChange={(e) => handleInputChange(e, "message")}
                textAreaFieldSize="textArea_large"
                textreawd="me-3"
              />
            ) : (
              <Tooltip
                withArrow
                positioning="top"
                content={{
                  children: <>{item.message}</>,
                  className: "ListingTooltip",
                }}
                relationship="description"
              >
                <div className="text-truncate">{item.message}</div>
              </Tooltip>
            )}
          </TableCell>
        );
      case "Audience":
        return (
          <TableCell
            className="Description"
            onClick={() => handleIsEdiRecord(index, "audience")}
          >
            {isEditing ? (
              <TextArea
                placeholder="Enter audience"
                value={isEditRecord.name.audience}
                onChange={(e) => handleInputChange(e, "audience")}
                textAreaFieldSize="textArea_large"
                textreawd="me-3"
              />
            ) : (
              <Tooltip
                withArrow
                positioning="top"
                content={{
                  children: <>{item.audience}</>,
                  className: "ListingTooltip",
                }}
                relationship="description"
              >
                <div className="text-truncate">{item.audience}</div>
              </Tooltip>
            )}
          </TableCell>
        );
      case "Frequency/When":
        return (
          <TableCell
            className="Description"
            onClick={() => handleIsEdiRecord(index, "frequency")}
          >
            {isEditing ? (
              <TextArea
                placeholder="Enter frequency"
                value={isEditRecord.name.time}
                onChange={(e) => handleInputChange(e, "frequency")}
                textAreaFieldSize="textArea_large"
                textreawd="me-3"
              />
            ) : (
              <Tooltip
                withArrow
                positioning="top"
                content={{
                  children: <>{item.time}</>,
                  className: "ListingTooltip",
                }}
                relationship="description"
              >
                <div className="text-truncate">{item.time}</div>
              </Tooltip>
            )}
          </TableCell>
        );
      case "Medium":
        return (
          <TableCell
            className="Description"
            onClick={() => handleIsEdiRecord(index, "medium")}
          >
            {isEditing ? (
              <CustomInput
                value={isEditRecord.name.medium}
                type="text"
                placeholder="Enter medium"
                handleChange={(value) => handleInputChange(value, "medium")}
                ref={mediumInputRef}
              />
            ) : (
              <Tooltip
                withArrow
                positioning="top"
                content={{
                  children: <>{item.medium}</>,
                  className: "ListingTooltip",
                }}
                relationship="description"
              >
                <div className="text-truncate">{item.medium}</div>
              </Tooltip>
            )}
          </TableCell>
        );
      case "Source":
        return (
          <TableCell
            className="Description"
            onClick={() => handleIsEdiRecord(index, "source")}
          >
            {isEditing ? (
              <CustomInput
                value={isEditRecord.name.source}
                type="text"
                placeholder="Enter source"
                handleChange={(value) => handleInputChange(value, "source")}
                ref={sourceInputRef}
              />
            ) : (
              <Tooltip
                withArrow
                positioning="top"
                content={{
                  children: <>{item.source}</>,
                  className: "ListingTooltip",
                }}
                relationship="description"
              >
                <div className="text-truncate">{item.source}</div>
              </Tooltip>
            )}
          </TableCell>
        );
      case "Expeditor":
        return (
          <TableCell
            className="Description"
            onClick={() => handleIsEdiRecord(index, "expeditor")}
          >
            {isEditing ? (
              <CustomInput
                value={isEditRecord.name.expeditor}
                type="text"
                placeholder="Enter expeditor"
                handleChange={(value) => handleInputChange(value, "expeditor")}
                ref={expeditatorInputRef}
              />
            ) : (
              <Tooltip
                withArrow
                positioning="top"
                content={{
                  children: <>{item.expeditor}</>,
                  className: "ListingTooltip",
                }}
                relationship="description"
              >
                <div className="text-truncate">{item.expeditor}</div>
              </Tooltip>
            )}
          </TableCell>
        );
      case "Status":
        return (
          <TableCell onClick={() => handleIsEdiRecord(index, "status")}>
            {isEditing ? (
              <CustomInput
                value={isEditRecord.name.status}
                type="text"
                placeholder="Enter status"
                handleChange={(value) => handleInputChange(value, "status")}
                ref={statusInputRef}
              />
            ) : (
              item.status
            )}
          </TableCell>
        );
      case "Purpose/Highlights":
        return (
          <TableCell
            className="Description"
            onClick={() => handleIsEdiRecord(index, "purpose")}
          >
            {isEditing ? (
              <TextArea
                placeholder="Enter highlights"
                value={isEditRecord.name.highlights}
                onChange={(e) => handleInputChange(e, "purpose")}
                textAreaFieldSize="textArea_large"
                textreawd="me-3"
              />
            ) : (
              <Tooltip
                withArrow
                positioning="top"
                content={{
                  children: <>{item.highlights}</>,
                  className: "ListingTooltip",
                }}
                relationship="description"
              >
                <div className="text-truncate">{item.highlights}</div>
              </Tooltip>
            )}
          </TableCell>
        );
      case "Expected Results/ Key Message":
        return (
          <TableCell
            className="Description"
            onClick={() => handleIsEdiRecord(index, "result")}
          >
            {isEditing ? (
              <TextArea
                placeholder="Enter result"
                value={isEditRecord.name.results}
                onChange={(e) => handleInputChange(e, "result")}
                textAreaFieldSize="textArea_large"
                textreawd="me-3"
              />
            ) : (
              <Tooltip
                withArrow
                positioning="top"
                content={{
                  children: <>{item.results}</>,
                  className: "ListingTooltip",
                }}
                relationship="description"
              >
                <div className="text-truncate">{item.results}</div>
              </Tooltip>
            )}
          </TableCell>
        );
      case "Category":
        return (
          <TableCell
            className="Description" 
            onClick={() => handleIsEdiRecord(index, "category")}
          >
              {isEditing ? (
                <DropDown
                  label="Category"
                  showLabel={false}
                  options={communicationCategoryOptions}
                  defaultVal={getLabelByType("communicationCategory", isEditRecord.name.category)}
                  onChange={(e) => handleInputChange(e, "category")}
                  isInlineFocus={true}
                />
              ) : (
                item?.id && getLabelByType("communicationCategory", item.category)
              )}
          </TableCell>
        );
      default:
        return null;
    }
  };

  const styles = useStyles();
  return sortedData.map((item, index) => (
    <TableRow key={item.id || index} ref={popoverRef}>
      {sortedColumnConfig
        .filter((col) => col.isVisible)
        .map((col) => renderTableCell(item, index, col))}
    </TableRow>
  ));
};

export default CommunicationPlanRow;
